<template>

  <div>
    <h5>{{ $t('Disable two-step verification') }}</h5>
    <p>{{ $t('If you disable two-step verification, the account will no longer have the protection of a second login step.') }}</p>
    <form
      class="shurt-conatiner"
      v-on:submit.prevent="disable()"
      :class="{ 'box-loading': loading }">
      <div class="form-group">
        <label>{{ $t('Password') }}</label>
        <input
          v-autofocus
          type="password"
          class="form-control"
          autocomplete="off"
          v-model="password">
        <ValidateMessage
          :error="validateErrors.password" />
      </div>
      <button
        type="submit"
        class="btn btn-primary">{{ $t('Desativar') }}</button>
    </form>
  </div>

</template>

<script>
export default {
  name: 'ProfileTwofaDisable',
  components: {
  },
  data () {
    return {
      loading: false,
      password: {},
      validateErrors: false
    }
  },
  created () {
  },
  computed: {
  },
  methods: {
    disable () {
      this.loading = true
      return this.axios.post('/auth/me/2fa/disable', {
        password: this.password
      }).then(res => {
        if (res.data && res.data.twofa_enable === false) {
          this.$store.dispatch('setMe').then(() => {
            this.$router.push('/config/security')
          })
        }
      }).catch(err => {
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
        this.loading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/Profile/ProfileTwofaDisable.vue